module.exports = __webpack_public_path__ + "img/001.c885bce1.png";